import components from './components';
import StoryController from './StoryController';
import storyTemplate from './story.html';

const module = angular.module('websked.story', []);

const toLoad = [
  StoryController,
  components
];

toLoad.forEach(fn => fn(module));

function routes($stateProvider) {
  $stateProvider
    .state('stories.story', {
      url: '/:id',
      template: storyTemplate,
      controller: 'StoryController',
      data: {
        pageTitle: {
          de: 'Artikel',
          en: 'Story',
          es: 'Artículo',
          fr: 'Article'
        }
      }
    })
    .state('story', {
      url: '/story/:id',
      redirectTo: 'stories.story'
    })
    .state('planning.story', {
      url: '/:id',
      template: storyTemplate,
      controller: 'StoryController',
      data: {
        pageTitle: {
          de: 'Artikel',
          en: 'Story',
          es: 'Artículo',
          fr: 'Article'
        }
      }
    });
}

module.config([
  '$stateProvider',
  routes
]);
